import React from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import ArtikelForm from "./Components/form";
import { addArtikel } from "../Reducers/actions";

const ArtikelInsertPage = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const submit = (vals) => {
    // Zet standaard waarden
    if (!vals.status) {
      vals.status = "actief";
    }
    
    dispatch(addArtikel(vals)).then((data) => {
      if (data.type === "ARTIKEL_ERROR") {
        alert(data.payload);
        return false;
      } else {
        navigate("/gastenverbruik/artikelen");
      }
    });
  };

  return (
    <div className="box box-default">
      <div className="box-header with-border">
        <h3 className="box-title">Artikel Toevoegen</h3>
      </div>
      
      <div className="row">
        <div className="col-md-12 no-float">
          <div className="box box-primary">
            <div className="box-body box-profile">
              <ArtikelForm onSubmit={submit} initialValues={{ status: "actief" }} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ArtikelInsertPage;